import SurveyService from "../../service/survey";

const Action = {
    GET_SURVEY: '[survey] GET SURVEY',
};

const ActionCreator = {
    getSurvey() {
        return async dispatch => {
            const list = await SurveyService.survey();
            dispatch({type: Action.GET_SURVEY, payload: list});
            return list;
        };
    }
};

export default {Action, ActionCreator};



// WEBPACK FOOTER //
// ./src/store/actionreducers/survey.js